module.exports = __webpack_public_path__ + "img/ddr.b98e45ea.png";